<template>
  <div>
    <div class="weui-pay">
      <div class="weui-pay-inner">
        <h1 class="weui-pay-title">付款金额(元)</h1>
        <div class="weui-pay-input">
          <strong class="weui-pay-strong">￥</strong>
          <input type="number" name="money" class="weui-pay-inputs" placeholder="请输入金额" @input="inputChange" v-model="rechargeMoney">
        </div>
      </div>
      <div class="weui-pay-btn">
        <a href="javascript:;" class="weui-btn weui-btn_primary" @click="pay">立即支付</a>
      </div>
    </div>
  </div>
</template>

<script>  
  import Util from '../../Util.js'

  export default {
    name: 'prepay',
    data() {
      return {
        open_id: false,
        union_id: false,
        cell_id: '',
        cellName: '橙行文化传媒',
        rechargeMoney: '',
        wechatCode: false,
      }
    },
    mounted() {
      let cell_id = Util.getUrlParam('cell_id');
      this.setCell(cell_id);
      document.title = '在线缴费'
      if (this.getParams('code')) {
        this.wechatCode = this.getParams('code');
        this.getUserOpenId();
      } else { // openID是判断是否是新用户 code是判断是否已经授权
        this.relogin();  
      }
    },
    methods: {
      relogin() {
        let cell_id = Util.getUrlParam('cell_id');
        const path = 'https://public.cxcamp.cn/#/cellPrePay?cell_id=' + cell_id;
        const url = encodeURIComponent(path); //获取#之前的当前路径
        const appid = 'wxf67dbc3f0fa0f537';
        window.location.href = 'http://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + url + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      },
      inputChange() {
        this.rechargeMoney = Util.isNumber(Util.inputChangeTwoDecimal(this.rechargeMoney))
      },
      selectMoney(obj, key) {
        for (let i of this.moneyList) {
          i.bool = false
        }
        this.moneyList[key].bool = true
        this.rechargeMoney = Util.changeTwoDecimal(obj.money)
        if (this.moneyList[key].gift > 0) {
          this.showMessage = true;
        } else {
          this.showMessage = false;
        }
      },
      pay() {
        if (this.rechargeMoney <= 0) {
          $.toast('支付金额需大于0', 'text');
          return
        }
        this.$http.post(Util.ApiUrl + `tool/generateCode`, {
          appName: 'PUBLIC-CXCAMP',
          money: this.rechargeMoney,
          openid: this.open_id,
          unionid: this.union_id,
          cell_id: this.cell_id,
          cell_name: this.cellName
        }).then(
          res => {
            if (res.data.code == 200) {
              this.callPay(res.data.data)
            } else {
              $.toast(res.data.desc, 'text');
              this.relogin();
            }
          },
          err => {
            console.log(err)
          }
        )
      },
      callPay(params) {
        var that = this
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId": params.appId, //公众号名称，由商户传入     
            "timeStamp": params.timeStamp, //时间戳，自1970年以来的秒数     
            "nonceStr": params.nonceStr, //随机串     
            "package": params.package,
            "signType": params.signType, //微信签名方式：     
            "paySign": params.paySign //微信签名 
          },
          res => {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              $.toast('支付成功', 'text');
              setTimeout(_ => {
                that.rechargeMoney = ''
                document.addEventListener(
                      "WeixinJSBridgeReady",
                    function() {
                        WeixinJSBridge.call("closeWindow");
                    },
                    false
                );
                // 苹果
                WeixinJSBridge.call("closeWindow");
              }, 2000)
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            }
          }
        );
      },
      setCell(cell_id) {
        this.$http.post(Util.ApiUrl + `tool/getCellName`, {
          cell_id: cell_id,
        }).then(
          res => {
            if (res.data.code == 200) {
              this.cellName = res.data.data;
              this.cell_id = cell_id;
            } else {
              $.toast(res.data.desc, 'text');
            }
          },
          err => {
            console.log(err)
          }
        )
      },
      getParams(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return (false);
      },
      getUserOpenId() {
        this.$http.post(Util.ApiUrl + `wx/authPb`, {
          code: this.wechatCode
        }).then(
          res => {
            if (res.data.code == 200) {
              this.open_id = res.data.data.raw.openid;
              this.union_id = res.data.data.raw.unionid;
              localStorage.setItem('open_id', this.open_id);
              localStorage.setItem('union_id', this.union_id);
            } else {
              $.toast(res.data.desc, 'text');
            }
          },
          err => {
            console.log(err)
          }
        )

      }
    }
  }
</script>

<style lang="less">
  .weui-pay-btn {
    position: fixed;
    bottom:1px;
    width: 100%;
    left:0;
  }
  .weui-pay-input::after {
    border: none;
  }
</style>